import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useAds } from "./useAds";

export default function AdsCarousel() {
  const { ads } = useAds("carousel");
  const [idx, setIdx] = useState(0);

  // Auto rotate every 5s
  useEffect(() => {
    if (ads.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 5000);
    return () => clearInterval(t);
  }, [ads.length]);

  if (ads.length === 0) return null;
  const a = ads[idx] || ads[0];

  return (
    <section className="bg-[#f8faff] py-10 md:py-12 px-6" data-testid="ads-carousel-section">
      <div className="max-w-5xl mx-auto">
        <div
          className="rounded-3xl overflow-hidden shadow-xl border border-black/5 relative"
          style={{
            backgroundColor: a.bg_color || "#0a4d33",
            color: a.text_color || "#FFFFFF",
          }}
          data-testid={`ads-carousel-slide-${a.id}`}
        >
          <div className="grid md:grid-cols-2 items-center">
            {a.image_url ? (
              <div className="aspect-[4/3] md:aspect-auto md:h-full bg-black/10 flex items-center justify-center overflow-hidden">
                <img src={a.image_url} alt={a.title || ""} className="w-full h-full object-cover" />
              </div>
            ) : (
              <div className="hidden md:block bg-black/10" />
            )}
            <div className="p-8 md:p-12">
              {a.title && <h3 className="font-headings font-black text-2xl md:text-3xl leading-tight">{a.title}</h3>}
              {a.subtitle && <p className="mt-2 text-base opacity-90">{a.subtitle}</p>}
              {a.body_text && <p className="mt-3 text-sm opacity-80 whitespace-pre-line">{a.body_text}</p>}
              {a.cta_label && a.cta_url && (
                <a
                  href={a.cta_url}
                  className="inline-flex items-center gap-2 mt-5 bg-white text-[#1a2332] font-headings font-bold rounded-xl px-5 py-3 text-sm shadow-md hover:scale-105 transition-transform"
                  data-testid={`ads-carousel-cta-${a.id}`}
                >
                  {a.cta_label} →
                </a>
              )}
            </div>
          </div>

          {ads.length > 1 && (
            <>
              <button
                onClick={() => setIdx((i) => (i - 1 + ads.length) % ads.length)}
                aria-label="Précédent"
                data-testid="ads-carousel-prev"
                className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/15 hover:bg-white/25 rounded-full w-9 h-9 flex items-center justify-center backdrop-blur-sm"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                onClick={() => setIdx((i) => (i + 1) % ads.length)}
                aria-label="Suivant"
                data-testid="ads-carousel-next"
                className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/15 hover:bg-white/25 rounded-full w-9 h-9 flex items-center justify-center backdrop-blur-sm"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5" data-testid="ads-carousel-dots">
                {ads.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    aria-label={`Slide ${i + 1}`}
                    className={`w-2 h-2 rounded-full transition-all ${i === idx ? "bg-white w-6" : "bg-white/50"}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
